import React from "react";
import { Col, Row } from "antd";
import ProfileHeader from "./ProfileHeader";
import ProfileInfoCard from "./ProfileInfoCard";
import ProfileSection from "./ProfileSection";
import "./profileOverview.css";

/**
 * Configuration-driven profile shell: header + responsive grid of cards.
 * `overviewConfig` is produced by profile mappers (e.g. patient `overviewConfig` on profile payload).
 */
const ProfileOverview = ({
  overviewConfig,
  actionIcons,
  actionData,
}) => {
  if (!overviewConfig) return null;

  const {
    displayName,
    preferredName,
    roleLabel,
    statusLabel,
    medicalRecordNumber,
    memberTitle,
    additionalPrimaryData,
    sections,
    avatar,
  } = overviewConfig;

  return (
    <div className="profile-overview-root">
      <ProfileHeader
        displayName={displayName}
        preferredName={preferredName}
        roleLabel={roleLabel}
        statusLabel={statusLabel}
        medicalRecordNumber={medicalRecordNumber}
        memberTitle={memberTitle}
        additionalPrimaryData={additionalPrimaryData}
        actionIcons={actionIcons}
        actionData={actionData}
        avatar={avatar}
      />
      <Row gutter={[20, 20]} className="profile-overview-body">
        {(sections || []).filter(item => item?.content).map((section) => (
          <Col key={section.id} {...(section.colProps || { xs: 24, lg: 12 })}>
            <ProfileInfoCard title={section.title} subtitle={section.subtitle}>
              <ProfileSection>{section.content}</ProfileSection>
            </ProfileInfoCard>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ProfileOverview;
